/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { ReactElement } from 'react';

// ours
import { StatusCalloutViewModel } from 'src/types/view-models/status-callout.view.model';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// icons and styles
import { IconCheck, IconWarning } from '@americanexpress/dls-react';
import styles from './StatusCallout.module.scss';

export default function StatusCallout(props: StatusCalloutViewModel): ReactElement {
    let containerClassName: string;
    switch (props.status) {
        case 'success':
            containerClassName = styles.success;
            break;
        case 'warning':
            containerClassName = styles.warning;
            break;
        case 'error':
            containerClassName = styles.error;
            break;
    }

    let icon: JSX.Element;
    switch (props.icon) {
        case 'check':
            icon = <IconCheck filled className={styles.icon} />;
            break;
        case 'warning':
            icon = <IconWarning className={styles.icon} />;
            break;
    }

    return (
        <div className={containerClassName}>
            <div className={styles.leftBar} />
            {icon}
            <Typography className={styles.text} variant={TypographyVariants.BODY}>
                {props.text}
            </Typography>
        </div>
    );
}
